<template>
  <section class="edit-policy-form width-700">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <pet-policy-form
        ref="policy-form"
        :form="form"
        :isRequired="isRequired"
        :editType="editType"
        :showBuyable="showBuyable"
        :isRefer="isRefer"
        :checkRefer="checkRefer"
        @getFormData="getFormData" />
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import PetPolicyForm from '@/views/quoting/modules/pet/form/pet-policy-form'

export default {
  name: 'editPersonalPolicyForm',
  components: {
    PetPolicyForm
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formData: {
        benefits: []
      }
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions31
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })

      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
        }
      }
    },
    // editType: {
    //   immediate: true,
    //   handler(val) {
    //     this.requireValid = val === 2? true: false
    //   }
    // },
  },
  methods: {
    submitForm(otherData = {}) {
      this.$refs['form'].validate(valid => {
        if(valid) {
          this.$refs['policy-form'].submitForm(otherData)
        }
      })

    },
    getFormData(data, otherData) {
      // 整合其他數據
      const result = {
        ...data,
        ...this.formData
      }
      this.$emit('getFormData', result, otherData)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
